import React from 'react'
import {Col, Row, Panel, FormGroup, FormControl, Button} from 'react-bootstrap'
import DateTime from 'react-datetime'

const RedemptionSearch = (props) => {
        return (
          <Panel className="order-filter">
            <Row>
              <Col md={6}>
                <FormGroup>
                  <FormControl onChange={props.onInputChange}
                               placeholder="customer number, email, mobile, user id, first name, last name"
                               value={props.searchValue}/>
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <DateTime timeFormat={false}
                            dateFormat="DD/MM/YYYY"
                            value={props.dateFromValue}
                            onChange={props.onDateFromChange}
                            closeOnSelect
                            inputProps={{
                              placeholder: 'Redemption date from'
                            }}/>
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <DateTime timeFormat={false}
                            dateFormat="DD/MM/YYYY"
                            value={props.dateToValue}
                            onChange={props.onDateToChange}
                            closeOnSelect
                            inputProps={{
                              placeholder: 'Redemption date to'
                            }}/>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <FormControl value={props.autoredemptionValue}
                               onChange={props.onAutoredemptionChange}
                               componentClass="select">
                    <option value="">[Autoredemption]</option>
                    <option value="true">YES</option>
                    <option value="false">NO</option>
                  </FormControl>
                </FormGroup>
              </Col>
              <Col md={6} className="actions">
                <Button className="red-ghost-btn"
                        onClick={props.onSearch}>Apply</Button>

                <Button className="grey-ghost-btn"
                        onClick={props.onClear}>Clear search/filters</Button>
              </Col>
            </Row>
          </Panel>
        );
};

export default RedemptionSearch;


// WEBPACK FOOTER //
// ./src/components/admin/staff-reward/redemptions/redemption-search.jsx